import { ArrowRight } from "lucide-react";

const CTA = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-600 to-purple-600 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl sm:text-5xl font-bold mb-6">
          ¿Listo para transformar tu consultorio?
        </h2>
        <p className="text-xl mb-8 text-blue-100">
          Únete a los primeros consultorios que están construyendo el futuro de
          la odontología digital
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/registrarse"
            className="px-8 py-4 bg-white text-blue-600 rounded-xl font-semibold text-lg hover:bg-blue-50 transition-all shadow-2xl hover:scale-105 flex items-center gap-2"
          >
            Comenzar ahora gratis
            <ArrowRight className="w-5 h-5" />
          </a>
          <button
            onClick={() =>
              window.open(
                "https://wa.me/4917670568851?text=Hola, necesito ayuda",
                "_blank"
              )
            }
            className="px-8 py-4 bg-white/10 backdrop-blur text-white rounded-xl font-semibold text-lg hover:bg-white/20 transition-all border-2 border-white/30"
          >
            Hablar con un asesor
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
